import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// Rename the name of the function:
const PriceIndexationForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    const apiObject = 'price_indexation'

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        {
            name: 'year',
            label: 'billing.price_indexation.year_label',
            type: 'text',
            placeholder: 'billing.price_indexation.year_placeholder',
            helperText: 'billing.price_indexation.year_helperText',
        },
        {
            name: 'percentage',
            label: 'billing.price_indexation.percentage_label',
            type: 'text',
            placeholder: 'billing.price_indexation.percentage_placeholder',
            helperText: 'billing.price_indexation.percentage_helperText',
        },
        {
            name: 'environment',
            label: 'billing.price_indexation.environment_label',
            type: 'dropdown',
            disabled_selected: 'billing.price_indexation.all_customers_label',
            showSearch: true,
            allowNoneOption: true,
            helperText: 'billing.price_indexation.environment_helperText',
            apiRequest: [{
                endpoint: 'get_environment_as_superuser_list',
                object: 'environment_as_superuser',
                params: { },
                useCache: true
            }],
        },
    ];

    return (
        <FormModal
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
            showDeleteButton={true}
        />
    );
};

export default PriceIndexationForm;
